import { cn } from '@/shared/utils/cn/cn.util';

import {
  JSON_GUTTER_CLASSES,
  JSON_GUTTER_LINE_CLASSES,
  JSON_GUTTER_LINE_ERROR_CLASSES,
} from '../structured.tokens';

import { type JsonGutterProps } from './JsonGutter.types';

/**
 * The line numbers.
 *
 * `aria-hidden`, because a screen reader announcing "1 2 3 4 5" before the code
 * is noise — the position of a problem is spoken by the error message, in words.
 *
 * Alignment is structural, not measured: the gutter shares the textarea's
 * `text-code` token (13px on an even 20px line) and the same block padding, so
 * one line-height lays both out and there is nothing to drift. That is also what
 * makes it true in jsdom, where every measurement is `0` forever.
 *
 * Presentation only (U5).
 */
export function JsonGutter({ lineCount, errorLine, scrollRef }: JsonGutterProps) {
  return (
    <div ref={scrollRef} aria-hidden className={JSON_GUTTER_CLASSES}>
      {Array.from({ length: lineCount }, (_, index) => index + 1).map((line) => (
        <span
          key={line}
          data-line={line}
          className={cn(
            JSON_GUTTER_LINE_CLASSES,
            line === errorLine && JSON_GUTTER_LINE_ERROR_CLASSES,
          )}
        >
          {line}
        </span>
      ))}
    </div>
  );
}
